import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const { useUnoSelector } = UnoStoreHooks;
const { Header: UIHeader } = UiComponents;

const Header = () => {
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const handleLogout = async () => {
    try {
      await axios.post(
        `${configData.config.UNO_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );
      window.location.href = `${configData?.config?.redirectUri}`;
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <>
      <UIHeader
        appLogo={null}
        showSearch={false}
        showDrawer={true}
        showThemeSwitch={false}
        logoutHandler={handleLogout}
        appName="View it 360 "
        userDetails={{
          name: userData?.user?.name,
          email: userData?.user?.email,
          image: userData?.user?.avatar,
          designation: userData?.user?.designation,
        }}
      />
    </>
  );
};

export default Header;
